import * as React from 'react';
import { IconProps } from '../types';

const IcChevronRight = (props:IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M8.5 21c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l7.3-7.3-7.3-7.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l8 8c.4.4.4 1 0 1.4l-8 8c-.2.2-.4.3-.7.3Z"
    />
  </svg>
);

export default IcChevronRight;